import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  LeadSection,
  AboutSection,
  CasesSection,
  RatingsSection,
  TeamSection,
  ContactsSection
  // PartnersSection
} from "../components/sections"
import Separator from "../components/separator"

const IndexPage = () => (
  <Layout>
    <SEO />
    <LeadSection title="Поможем ликвидировать компанию, сопроводить процедуру банкротства юридического лица." />
    <AboutSection title={<>Когда стоит обратиться&nbsp;к&nbsp;нам</>} />
    <CasesSection title="Наши кейсы" />
    <Separator />
    <RatingsSection title="Наши адвокаты в рейтингах" />
    <Separator />
    {/* <PartnersSection title="О нас пишут" /> */}
    {/* <Separator /> */}
    <TeamSection title="Команда" />
    <Separator />
    <ContactsSection title="Контакты" />
  </Layout>
)

export default IndexPage
